module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "h-30"
  }, [_c('span', {
    staticClass: "form-item"
  }, [_vm._v("条件间逻辑关系")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.checkValid
    }
  }, [_vm._v("检查是否正确")])]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childValue),
      expression: "childValue"
    }],
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.childValue)
    },
    on: {
      "input": [function($event) {
        _vm.childValue = $event
      }, _vm.change]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips lh-20"
  }, [_vm._v("\n    说明：为空则全部条件为AND关系，填写条件名和AND、OR以及括号、双引号(均为英文半角)来组合条件间的关系，慎重以免报错，若解析失败，则会以全部为AND来解析。例子：(\"条件名1\"AND\"条件名2\")OR(\"条件名1\"AND\"条件名3\")\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46c953fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/conditionCheck.vue
// module id = 1845
// module chunks = 2